
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48.611 51.845","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2107","transform":"translate(-108 -209)"}},[_c('path',{attrs:{"d":"M132.306 260.845a2.253 2.253 0 01-2.253-2.253v-6.043a2.253 2.253 0 014.506 0v6.043a2.253 2.253 0 01-2.253 2.253z","data-name":"Path 35"}}),_c('path',{attrs:{"d":"M142.327 254.27h-20.04a2.253 2.253 0 01-2.188-1.715l-6.192-25.194a2.255 2.255 0 01.627-2.162l16.211-15.571a2.252 2.252 0 013.122 0l16.21 15.571a2.247 2.247 0 01.627 2.162l-6.191 25.194a2.254 2.254 0 01-2.186 1.715zm-18.271-4.506h16.5l5.461-22.216-13.714-13.171-13.713 13.171z","data-name":"Path 36"}}),_c('path',{attrs:{"d":"M110.253 234.729a2.253 2.253 0 01-1.562-3.876l22.053-21.222a2.255 2.255 0 013.124 0l22.052 21.222a2.253 2.253 0 11-3.123 3.245l-20.49-19.72-20.492 19.72a2.246 2.246 0 01-1.562.631z","data-name":"Path 37"}}),_c('g',{attrs:{"data-name":"Group 2"}},[_c('path',{attrs:{"d":"M132.123 244.618a6.018 6.018 0 01-6.012-6.011 1.127 1.127 0 012.253 0 3.758 3.758 0 007.516 0 1.127 1.127 0 112.253 0 6.017 6.017 0 01-6.01 6.011z","data-name":"Path 38"}})]),_c('circle',{attrs:{"cx":"5.112","cy":"5.112","r":"5.112","data-name":"Ellipse 1","transform":"translate(126.783 224.743)"}})])])
          )
        }
      }
    